import MinNightRequirementWarning from "legacy/boater-reservation-flow/MinNightRequirementWarning"
import DockwaPlusOffer from "legacy/boater-reservation-flow/price-estimate/dockwa-plus-sign-up/DockwaPlusOffer"
import PropTypes from "prop-types"
import React from "react"

import LineItems from "src/components/LineItems/LineItems"

class PricingSummary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showVerticalDataError: false,
    }
    this.setDockType = this.setDockType.bind(this)
    this.needsVerticalData = this.needsVerticalData.bind(this)
    this.presentmentCurrency =
      window.currentMarina?.presentmentCurrency || "USD"
  }

  setDockType() {
    if (!this.needsVerticalData()) {
      const { marina } = this.props

      Amplitude.trackEvent("reservation_flow:continue_to_reserve_pressed", {
        marina_id: marina.mcomId,
        marina_name: marina.name,
        experience_name: "reservation_flow",
      })

      this.props.routeTo("next")
    } else {
      this.setState({ showVerticalDataError: true })
      this.props.setGlobalState({ estimateBtnPressed: true })
    }
  }

  needsVerticalData() {
    const {
      boatCreated,
      draftMissing,
      heightMissing,
      height: boatHeight,
      draft: boatDraft,
    } = this.props.state

    const needVerticalData =
      boatCreated !== "previously" || draftMissing || heightMissing
    return needVerticalData && !(boatHeight || boatDraft)
  }

  render() {
    const { dockwaPlusOffer, userId, minimumNights, nextDisabled } =
      this.props.state
    const { showVerticalDataError } = this.state
    const {
      handleOpenModal,
      lineItems,
      loadingProductInformation,
      loadingPricing,
    } = this.props

    const offerComponent =
      dockwaPlusOffer && !loadingPricing ? (
        <div key={"dockwa-plus-offer"}>
          <DockwaPlusOffer
            dockwaPlusOffer={dockwaPlusOffer}
            userId={userId}
            handleOpenModal={handleOpenModal}
            loadingProductInformation={loadingProductInformation}
          />
        </div>
      ) : null

    const disableNext =
      nextDisabled || loadingPricing || lineItems === undefined

    const minNightRequirement = minimumNights ? (
      <div>
        <MinNightRequirementWarning numberOfNights={minimumNights} />
      </div>
    ) : null

    const helperText =
      (lineItems && lineItems.length > 0) || loadingPricing ? null : (
        <div className="mt-4 text-center text-base text-gray-600">
          Enter a length overall, height, draft, arrival and departure to view
          price.
        </div>
      )

    return (
      <div className="flex flex-col gap-6">
        {helperText}
        <LineItems
          lineItems={lineItems}
          loading={loadingPricing}
          loadingItems={2}
          currency={this.presentmentCurrency}
        />
        {minNightRequirement}
        {offerComponent}
        {showVerticalDataError && (
          <span className="text-danger font-semibold">
            Please enter the height or draft of your vessel to continue.
          </span>
        )}
        <button
          type="button"
          className="btn btn-primary center-block"
          onClick={this.setDockType}
          disabled={disableNext}
        >
          Continue to Reserve
        </button>
      </div>
    )
  }
}

PricingSummary.propTypes = {
  state: PropTypes.shape({
    boatCreated: PropTypes.string,
    draftMissing: PropTypes.bool,
    heightMissing: PropTypes.bool,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    draft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dockwaPlusOffer: PropTypes.object,
    userId: PropTypes.number,
    minimumNights: PropTypes.number,
    nextDisabled: PropTypes.bool,
  }).isRequired,
  marina: PropTypes.shape({
    mcomId: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  routeTo: PropTypes.func.isRequired,
  setGlobalState: PropTypes.func.isRequired,
  handleOpenModal: PropTypes.func,
  lineItems: PropTypes.array,
  loadingProductInformation: PropTypes.bool,
  loadingPricing: PropTypes.bool,
}

export default PricingSummary
